/* global axios */
import ApiClient from './ApiClient';

class VoipLeadsAPI extends ApiClient {
  constructor() { super('voip_leads', { accountScoped: true }); }

  list(filters = {}, { page = 1, perPage = 25 } = {}) {
    const p = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (v == null || v === '') return;
      if (Array.isArray(v)) v.forEach(x => p.append(`${k}[]`, x));
      else p.append(k, v);
    });
    p.append('page', page); p.append('per_page', perPage);
    return axios.get(`${this.url}?${p.toString()}`);
  }
  counts() { return axios.get(`${this.url}/counts`); }
  show(id) { return axios.get(`${this.url}/${id}`); }
  score(id) { return axios.post(`${this.url}/${id}/score`); }
  listAppointments(id) { return axios.get(`${this.url}/${id}/appointments`); }
  createAppointment(id, payload) { return axios.post(`${this.url}/${id}/appointments`, payload); }
  updateAppointment(contactId, apptId, payload) {
    return axios.patch(`${this.url}/${contactId}/appointments/${apptId}`, payload);
  }
  // Phase 2.5 E — Coach AI
  getCoach(id) { return axios.get(`${this.url}/${id}/coach`); }
  generateCoach(id, { force = false } = {}) {
    return axios.post(`${this.url}/${id}/coach`, { force });
  }
}

export default new VoipLeadsAPI();
